import { jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { renderBlock } from '../../BlockRenderer/renderBlock.js';
import { renderChildren } from '../../BlockRenderer/renderChildren.js';
import { getBorderStyle } from '../../utils/getBorderStyle.js';
import { style } from '../../utils/style.js';
import { renderCardHighlight } from './renderCardHighlight.js';
const cardBaseStyle = 'relative h-full';
const CARD_SIZE_MAP = {
    small: 'lg:min-w-64',
    normal: 'lg:min-w-80 xl:min-w-96',
    big: 'lg:min-w-[515px]',
};
export const renderCarouselCards = ({ noCardBorder, cardSize = 'normal', isNavButtons = false, ...rest }) => {
    const { blocks: childBlocks } = rest.block || {};
    const someCardsHighlighted = childBlocks?.some(isCardHighlighted);
    const defaultPadding = isNavButtons ? { defaultPadding: 'p-6xl pb-m' } : {};
    return renderChildren({
        ...rest,
        renderProps: (block, options, blockIndex) => (_jsxs("div", { className: cardWrapperStyle(block, { someCardsHighlighted }), children: [renderBlock(block, options, {
                    className: cardStyle(block, {
                        someCardsHighlighted,
                        showBorder: !noCardBorder,
                        cardSize,
                    }),
                    ...defaultPadding,
                    blockIndex,
                }), isCardHighlighted(block)
                    ? renderCardHighlight({ className: 'absolute top-0 -right-4 z-40' })
                    : null] }, String(blockIndex))),
    });
};
const cardWrapperStyle = (_, { someCardsHighlighted }) => style(cardBaseStyle, someCardsHighlighted && (isCardHighlighted(_) ? 'pt-3xl' : 'pt-3xl sm:pt-16'));
const cardStyle = (_, { someCardsHighlighted, showBorder, cardSize = 'normal', }) => style(cardBaseStyle, 'min-w-80', CARD_SIZE_MAP[cardSize], // TODO fix для RecommendationCard
someCardsHighlighted && (isCardHighlighted(_) ? 'pt-3xl sm:pt-16' : 'pt-3xl'), getBorderStyle(showBorder), showBorder && 'h-full');
const isCardHighlighted = (_) => _?.content && 'isHighlighting' in _.content && _.content.isHighlighting;
//# sourceMappingURL=renderCarouselCards.js.map